import UsdIcon from '@/assets/icons/usd.svg?react'
import { formatNumber } from '@/utils'
import { Plural } from '@lingui/react/macro'
import { Star } from 'lucide-react'
import { MissionBadge } from './MissionBadge'

type MissionRewardBadgeProps = {
  amount: number
  rewardType?: string | null
  className?: string
}

export const MissionRewardBadge = ({ amount, rewardType, className }: MissionRewardBadgeProps) => {
  const isUsd = rewardType === 'usd'

  return amount > 0 ? (
    <MissionBadge variant={isUsd ? 'yellow' : 'success'} className={className}>
      {isUsd ? <UsdIcon className="h-[15px] w-[9px]" /> : <Star size={15} />}
      {isUsd ? `${formatNumber(amount, 2)} USD` : <Plural value={amount} one="# point" other="# points" />}
    </MissionBadge>
  ) : null
}
